const ICON_PATHS = {
  shield: (
    <path
      d="M32 4L8 14v14c0 12.2 10.2 23.6 24 26 13.8-2.4 24-13.8 24-26V14L32 4z"
      fill="url(#shieldGradient)"
    />
  ),
  arc: (
    <path
      d="M20 38c0-6.6 5.4-12 12-12s12 5.4 12 12"
      stroke="#E5B80B"
      strokeWidth="3.5"
      strokeLinecap="round"
      fill="none"
    />
  ),
  arrow: (
    <path
      d="M32 22v12M32 22l-6 6M32 22l6 6"
      stroke="#E5B80B"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
  ),
  coin: (
    <>
      <circle cx="32" cy="36" r="9" fill="#E5B80B" opacity="0.95" />
      <path
        d="M29 36l2.5 2.5L36 33"
        stroke="#7F1D1D"
        strokeWidth="2.2"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </>
  ),
};

export function SimCollectLogoIcon({ size = 48, className = "" }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden="true"
    >
      <defs>
        <linearGradient id="shieldGradient" x1="8" y1="4" x2="56" y2="58" gradientUnits="userSpaceOnUse">
          <stop stopColor="#DC2626" />
          <stop offset="1" stopColor="#B91C1C" />
        </linearGradient>
        <linearGradient id="shineGradient" x1="20" y1="10" x2="44" y2="30" gradientUnits="userSpaceOnUse">
          <stop stopColor="#E5B80B" stopOpacity="0.35" />
          <stop offset="1" stopColor="#E5B80B" stopOpacity="0" />
        </linearGradient>
      </defs>
      {ICON_PATHS.shield}
      <ellipse cx="28" cy="18" rx="14" ry="10" fill="url(#shineGradient)" />
      {ICON_PATHS.arc}
      {ICON_PATHS.arrow}
      {ICON_PATHS.coin}
    </svg>
  );
}

export default function SimCollectLogo({
  variant = "full",
  theme = "dark",
  iconSize = 44,
  className = "",
}) {
  const isDarkTheme = theme === "dark";
  // Sim = gold always; Collect = red always (brighter on dark surfaces)
  const simClass = "text-accent";
  const collectClass = isDarkTheme ? "text-collect-muted" : "text-collect";
  const textMuted = isDarkTheme ? "text-white/45" : "text-primary/55";

  if (variant === "icon") {
    return <SimCollectLogoIcon size={iconSize} className={className} />;
  }

  return (
    <div className={`inline-flex items-center gap-3 ${className}`}>
      <SimCollectLogoIcon size={iconSize} />
      {variant === "full" && (
        <div className="flex flex-col leading-none">
          <span className="text-xl font-bold tracking-tight">
            <span className={simClass}>Sim</span>
            <span className={collectClass}>Collect</span>
          </span>
          <span className={`mt-1 text-[10px] font-medium uppercase tracking-[0.2em] ${textMuted}`}>
            Debt Recovery Platform
          </span>
        </div>
      )}
      {variant === "wordmark" && (
        <span className="text-xl font-bold tracking-tight">
          <span className={simClass}>Sim</span>
          <span className={collectClass}>Collect</span>
        </span>
      )}
    </div>
  );
}
